const imageMapper = (image: any) => {
  const value: any = {};
  if (image.editing !== undefined) value.editing = image.editing;
  if (image.uploading !== undefined) value.uploading = image.uploading;
  if (image.metadata !== undefined) value.metadata = image.metadata;
  return value;
};

export default imageMapper;
